import React from "react";
import {
  PagesHero,
  Catalogue,
  Gallery,
  Newsletter,
  MainStats,
  SteelSupply,
  QuickOverview,
} from "../components";
import { useTranslation } from "../hooks/useTranslation";

function Products() {
  const { t } = useTranslation();
  
  return (
    <>
      <PagesHero
        title={t("pages.products.title")}
        description={t("pages.products.description")}
        backgroundImage="/assets/images/productsHero.jpg"
      />
      <MainStats />
      <QuickOverview />
      <Catalogue />
      <SteelSupply />
      <Gallery />
      <Newsletter />
    </>
  );
}

export default Products;
